import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { array, number, object, string } from 'yup';

export function useIntakeIncomeSchema() {
    const { t } = useTranslation();
    return useMemo(
        () =>
            object().shape({
                income: array()
                    .of(
                        object().shape({
                            incomeTypeId: string().required(),
                            incomeTypeName: string().required(),
                            amount: number()
                                .transform((value) => (value === '' || Number.isNaN(value) ? null : value))
                                .typeError(t('invalidNumber'))
                                .min(0, t('invalidNumber'))
                                .nullable(),
                        }),
                    )
                    .required(),
            }),
        [t],
    );
}
